const enLanding = {
    // Header
    landingNavFeatures: "Features",
    landingNavHowItWorks: "How it works",
    landingNavPricing: "Plans",
    landingOpenApp: "Open the app",

    // Hero
    landingHeroEyebrow: "AI FOOTBALL PREDICTIONS",
    landingHeroTitle: "Read the match before it is played",
    landingHeroSubtitle: "Score Vision crosses form, head to head records and live odds to give you the probabilities of a match in seconds: winner, goals, exact score and the bets worth taking.",
    landingHeroPrimary: "Analyse a match",
    landingHeroSecondary: "See the plans",
    landingHeroNotice: "Pay by mobile money or card · Plan active straight away",

    // Figures
    landingStatLeagues: "Leagues covered",
    landingStatLeaguesValue: "Europe & Africa",
    landingStatSpeed: "An analysis in",
    landingStatSpeedValue: "Seconds",
    landingStatPrice: "From",
    landingStatPriceValue: "2 500 FCFA",

    // Features
    landingFeaturesTitle: "What an analysis gives you",
    landingFeaturesSubtitle: "Every match is read the same way, so you compare like with like",
    landingFeatureProbabilitiesTitle: "Win, draw, loss",
    landingFeatureProbabilitiesText: "The three outcomes as probabilities, next to the bookmakers' odds for the same match.",
    landingFeatureGoalsTitle: "Goals and over / under",
    landingFeatureGoalsText: "Over and under from 0.5 to 3.5 goals, for the match and for each side on its own.",
    landingFeatureScoreTitle: "Exact score",
    landingFeatureScoreText: "The most likely scorelines, ranked, with the chance given to each of them.",
    landingFeatureBetsTitle: "Recommended bets",
    landingFeatureBetsText: "The picks the model is most confident in, each with its probability and its odds.",
    landingFeatureReasoningTitle: "The reasoning",
    landingFeatureReasoningText: "Why the model reads the match this way, written out in French and in English.",
    landingFeatureHistoryTitle: "Your history",
    landingFeatureHistoryText: "Every analysis is kept, so reopening one costs you nothing from your daily quota.",

    // How it works
    landingHowTitle: "Three steps",
    landingHowStepOneTitle: "Pick the two teams",
    landingHowStepOneText: "Search any club, or pick a fixture from the matches coming up.",
    landingHowStepTwoTitle: "Run the analysis",
    landingHowStepTwoText: "The model crosses recent form, the head to head record and the live odds.",
    landingHowStepThreeTitle: "Read the predictions",
    landingHowStepThreeText: "Probabilities, goals, exact scores and recommended bets, on one screen.",

    // Plans
    landingPricingTitle: "Plans that fit how much you play",
    landingPricingSubtitle: "Pay for the days you need, from one week to one month. Nothing renews without you.",
    landingPricingCta: "See all the plans",
    landingPricingPerDay: "{{count}} analyses per day",
    landingPricingUnlimited: "Unlimited analyses",

    // Referral
    landingReferralTitle: "Invite, and you both pay less",
    landingReferralText: "Share your code: whoever signs up with it gets a discount on their first plan, and so do you on your next one.",

    // Closing
    landingCtaTitle: "Your next match is waiting",
    landingCtaText: "Create an account and run your first analysis in under a minute.",
    landingCtaButton: "Get started",

    // Footer
    landingFooterTagline: "AI football predictions, built for Cameroon and beyond.",
    landingFooterProduct: "Product",
    landingFooterSupport: "Support",
    landingFooterContact: "Contact us",
    landingFooterRights: "© {{year}} Score Vision. All rights reserved.",
    landingFooterResponsible: "Predictions are for information only. Betting involves risk — play responsibly, and only with what you can afford to lose. 18+."
}

export default enLanding
